import classnames from 'classnames';
import { HTMLAttributes } from 'react';

import { useSliderDispatch, useSliderState } from './context';

type NavButtonProps = HTMLAttributes<HTMLButtonElement> & {
  dir: 'next' | 'previous';
  disabled?: boolean;
};

function NavButton({
  className,
  dir = `next`,
  disabled,
  ...props
}: NavButtonProps) {
  const nextButton = dir === `next`;

  return (
    <button
      type="button"
      className={classnames(
        `rounded bg-white px-4 shadow-sm transition-transform duration-75`,
        className,
        {
          'hover:translate-x-1': nextButton,
          'hover:-translate-x-1': !nextButton,
          'transform hover:text-cornflower': !disabled,
          'cursor-not-allowed opacity-50': disabled,
        },
      )}
      {...props}
    >
      {nextButton ? <>&#8594;</> : <>&#8592;</>}
    </button>
  );
}

export default function SliderNav() {
  const { nextItem, previousItem } = useSliderDispatch();
  const { isFirstItemActive, isLastItemActive } = useSliderState();

  return (
    <>
      <div className="right-full order-1 px-0 lg:absolute lg:px-3">
        <NavButton
          dir="previous"
          {...(!isFirstItemActive && { onClick: previousItem })}
          disabled={isFirstItemActive}
        />
      </div>
      <div className="left-full order-3 px-0 lg:absolute lg:px-3">
        <NavButton
          dir="next"
          {...(!isLastItemActive && { onClick: nextItem })}
          disabled={isLastItemActive}
        />
      </div>
    </>
  );
}
